var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValReportInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 293,
    viewBox: "0 0 406 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 41.6313C36.7363 32.6966 41.9626 25.4423 48.3996 25.4423H315.197C321.634 25.4423 326.86 32.6966 326.86 41.6313V276.372C326.86 285.307 321.634 292.561 315.197 292.561H48.3996C41.9626 292.561 36.7363 285.307 36.7363 276.372V41.6313Z",
    fill: "url(#paint0_radial_706_27619)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 41.6313C36.7363 32.6966 41.9626 25.4423 48.3996 25.4423H315.197C321.634 25.4423 326.86 32.6966 326.86 41.6313V276.372C326.86 285.307 321.634 292.561 315.197 292.561H48.3996C41.9626 292.561 36.7363 285.307 36.7363 276.372V41.6313Z",
    fill: "url(#paint1_linear_706_27619)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 41.6313C36.7363 32.6966 41.9626 25.4423 48.3996 25.4423H315.197C321.634 25.4423 326.86 32.6966 326.86 41.6313V276.372C326.86 285.307 321.634 292.561 315.197 292.561H48.3996C41.9626 292.561 36.7363 285.307 36.7363 276.372V41.6313Z",
    fill: "url(#paint2_radial_706_27619)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 41.6313C36.7363 32.6966 41.9626 25.4423 48.3996 25.4423H315.197C321.634 25.4423 326.86 32.6966 326.86 41.6313V276.372C326.86 285.307 321.634 292.561 315.197 292.561H48.3996C41.9626 292.561 36.7363 285.307 36.7363 276.372V41.6313Z",
    fill: "url(#paint3_radial_706_27619)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 41.6313C36.7363 32.6966 41.9626 25.4423 48.3996 25.4423H315.197C321.634 25.4423 326.86 32.6966 326.86 41.6313V276.372C326.86 285.307 321.634 292.561 315.197 292.561H48.3996C41.9626 292.561 36.7363 285.307 36.7363 276.372V41.6313Z",
    fill: "url(#paint4_linear_706_27619)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 41.6313C36.7363 32.6966 41.9626 25.4423 48.3996 25.4423H315.197C321.634 25.4423 326.86 32.6966 326.86 41.6313V276.372C326.86 285.307 321.634 292.561 315.197 292.561H48.3996C41.9626 292.561 36.7363 285.307 36.7363 276.372V41.6313Z",
    fill: "url(#paint5_linear_706_27619)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 41.6313C36.7363 32.6966 41.9626 25.4423 48.3996 25.4423H315.197C321.634 25.4423 326.86 32.6966 326.86 41.6313V276.372C326.86 285.307 321.634 292.561 315.197 292.561H48.3996C41.9626 292.561 36.7363 285.307 36.7363 276.372V41.6313Z",
    fill: "#FAFAFD",
    fillOpacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.23 262.184L120.683 253.286L127.761 261.586L117.301 270.477L110.23 262.184Z",
    fill: "#007BCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.419 202.853L201.925 193.33L209.499 196.12L205.993 205.643L198.419 202.853Z",
    fill: "#E4E6EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.898 33.2822L154.499 23.5026L162.277 26.3682L158.676 36.1478L150.898 33.2822Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M353.595 90.6981L363.69 91.794L362.813 99.8133L352.718 98.7175L353.595 90.6981Z",
    fill: "#487390"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.497 41.8619L317.254 33.4172L324.23 46.4035L308.473 54.8481L301.497 41.8619Z",
    fill: "#9ECAFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2537 187.186L45.6287 173.606L56.8182 164.008L68.4432 177.589L57.2537 187.186Z",
    fill: "#D1E4FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.854 61.4394L115.949 62.5352L115.072 70.5545L104.977 69.4587L105.854 61.4394Z",
    fill: "#007BCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M273.657 133.103L284.109 124.206L291.187 132.506L280.728 141.397L273.657 133.103Z",
    fill: "#9ECAFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M307.959 86.1658C312.989 75.5853 325.676 71.0755 336.274 76.1022C346.882 81.1188 351.395 93.7768 346.365 104.357C341.801 113.944 330.97 118.546 321.092 115.596L315.241 119.62L314.663 112.424C306.539 106.546 303.497 95.5503 307.959 86.1658Z",
    fill: "#C0C6DC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M325.126 105.009L316.86 98.9789L319.71 95.0873L324.203 98.3607L333.127 86.9999L336.93 89.9795L325.126 105.009Z",
    fill: "#49454F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M312.519 224.58C307.916 199.572 343.847 191.453 349.27 216.271C353.873 241.28 317.942 249.398 312.519 224.58ZM335.217 254.413L340.039 253.323L339.154 248.929C342.497 247.864 345.544 246.215 348.208 244.117L351.1 247.437L354.773 244.007L351.878 240.682C354.213 238.097 356.097 235.108 357.437 231.86L361.569 233.221L363.113 228.371L358.986 227.01C359.76 223.652 359.978 220.118 359.56 216.542L363.819 215.579L362.818 210.606L358.558 211.569C357.565 208.123 356.004 204.992 354.004 202.26L357.247 199.234L353.969 195.473L350.722 198.503C348.247 196.117 345.377 194.203 342.25 192.852L343.612 188.566L338.938 187.023L337.576 191.304C334.336 190.541 330.92 190.355 327.457 190.827L326.573 186.433L321.751 187.523L322.636 191.917C319.292 192.982 316.246 194.631 313.582 196.729L310.69 193.409L307.017 196.839L309.911 200.164C307.577 202.749 305.693 205.738 304.353 208.986L300.221 207.625L298.677 212.475L302.804 213.836C302.03 217.194 301.812 220.729 302.23 224.304L297.97 225.267L298.972 230.24L303.232 229.277C304.225 232.723 305.786 235.855 307.786 238.586L304.543 241.613L307.82 245.373L311.068 242.343C313.543 244.729 316.413 246.643 319.54 247.994L318.178 252.281L322.852 253.823L324.214 249.542C327.454 250.305 330.87 250.491 334.333 250.019L335.217 254.413Z",
    fill: "#C0C6DC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M354.026 165.448C348.478 151.174 369.965 142.667 375.661 156.835C381.208 171.108 359.721 179.615 354.026 165.448ZM368.786 194.17L380.908 190.243L378.655 183.246C380.639 181.995 382.419 180.493 383.965 178.797L390.548 182.185L396.345 170.791L390.009 167.53C390.663 164.934 390.924 162.22 390.747 159.477L397.906 157.159L393.981 144.974L386.823 147.292C385.471 145.129 383.827 143.209 381.961 141.566L385.005 135.582L373.658 129.741L370.613 135.725C368.198 135.163 365.687 134.945 363.151 135.108L360.898 128.111L348.776 132.038L351.029 139.034C348.714 140.493 346.679 142.295 344.968 144.347L338.632 141.086L332.836 152.48L339.418 155.869C338.955 158.122 338.784 160.451 338.937 162.803L331.778 165.122L335.703 177.308L342.861 174.989C344.213 177.153 345.858 179.073 347.724 180.716L344.175 187.691L355.523 193.531L359.071 186.556C361.486 187.118 363.998 187.336 366.533 187.174L368.786 194.17Z",
    fill: "url(#paint6_radial_706_27619)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M354.026 165.448C348.478 151.174 369.965 142.667 375.661 156.835C381.208 171.108 359.721 179.615 354.026 165.448ZM368.786 194.17L380.908 190.243L378.655 183.246C380.639 181.995 382.419 180.493 383.965 178.797L390.548 182.185L396.345 170.791L390.009 167.53C390.663 164.934 390.924 162.22 390.747 159.477L397.906 157.159L393.981 144.974L386.823 147.292C385.471 145.129 383.827 143.209 381.961 141.566L385.005 135.582L373.658 129.741L370.613 135.725C368.198 135.163 365.687 134.945 363.151 135.108L360.898 128.111L348.776 132.038L351.029 139.034C348.714 140.493 346.679 142.295 344.968 144.347L338.632 141.086L332.836 152.48L339.418 155.869C338.955 158.122 338.784 160.451 338.937 162.803L331.778 165.122L335.703 177.308L342.861 174.989C344.213 177.153 345.858 179.073 347.724 180.716L344.175 187.691L355.523 193.531L359.071 186.556C361.486 187.118 363.998 187.336 366.533 187.174L368.786 194.17Z",
    fill: "url(#paint7_radial_706_27619)",
    fillOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M354.026 165.448C348.478 151.174 369.965 142.667 375.661 156.835C381.208 171.108 359.721 179.615 354.026 165.448ZM368.786 194.17L380.908 190.243L378.655 183.246C380.639 181.995 382.419 180.493 383.965 178.797L390.548 182.185L396.345 170.791L390.009 167.53C390.663 164.934 390.924 162.22 390.747 159.477L397.906 157.159L393.981 144.974L386.823 147.292C385.471 145.129 383.827 143.209 381.961 141.566L385.005 135.582L373.658 129.741L370.613 135.725C368.198 135.163 365.687 134.945 363.151 135.108L360.898 128.111L348.776 132.038L351.029 139.034C348.714 140.493 346.679 142.295 344.968 144.347L338.632 141.086L332.836 152.48L339.418 155.869C338.955 158.122 338.784 160.451 338.937 162.803L331.778 165.122L335.703 177.308L342.861 174.989C344.213 177.153 345.858 179.073 347.724 180.716L344.175 187.691L355.523 193.531L359.071 186.556C361.486 187.118 363.998 187.336 366.533 187.174L368.786 194.17Z",
    fill: "url(#paint8_linear_706_27619)",
    fillOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M354.026 165.448C348.478 151.174 369.965 142.667 375.661 156.835C381.208 171.108 359.721 179.615 354.026 165.448ZM368.786 194.17L380.908 190.243L378.655 183.246C380.639 181.995 382.419 180.493 383.965 178.797L390.548 182.185L396.345 170.791L390.009 167.53C390.663 164.934 390.924 162.22 390.747 159.477L397.906 157.159L393.981 144.974L386.823 147.292C385.471 145.129 383.827 143.209 381.961 141.566L385.005 135.582L373.658 129.741L370.613 135.725C368.198 135.163 365.687 134.945 363.151 135.108L360.898 128.111L348.776 132.038L351.029 139.034C348.714 140.493 346.679 142.295 344.968 144.347L338.632 141.086L332.836 152.48L339.418 155.869C338.955 158.122 338.784 160.451 338.937 162.803L331.778 165.122L335.703 177.308L342.861 174.989C344.213 177.153 345.858 179.073 347.724 180.716L344.175 187.691L355.523 193.531L359.071 186.556C361.486 187.118 363.998 187.336 366.533 187.174L368.786 194.17Z",
    fill: "url(#paint9_linear_706_27619)",
    fillOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M354.026 165.448C348.478 151.174 369.965 142.667 375.661 156.835C381.208 171.108 359.721 179.615 354.026 165.448ZM368.786 194.17L380.908 190.243L378.655 183.246C380.639 181.995 382.419 180.493 383.965 178.797L390.548 182.185L396.345 170.791L390.009 167.53C390.663 164.934 390.924 162.22 390.747 159.477L397.906 157.159L393.981 144.974L386.823 147.292C385.471 145.129 383.827 143.209 381.961 141.566L385.005 135.582L373.658 129.741L370.613 135.725C368.198 135.163 365.687 134.945 363.151 135.108L360.898 128.111L348.776 132.038L351.029 139.034C348.714 140.493 346.679 142.295 344.968 144.347L338.632 141.086L332.836 152.48L339.418 155.869C338.955 158.122 338.784 160.451 338.937 162.803L331.778 165.122L335.703 177.308L342.861 174.989C344.213 177.153 345.858 179.073 347.724 180.716L344.175 187.691L355.523 193.531L359.071 186.556C361.486 187.118 363.998 187.336 366.533 187.174L368.786 194.17Z",
    fill: "#FAFAFD",
    fillOpacity: 0.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.341 75.4483C32.7935 61.1745 54.2802 52.6672 59.9768 66.8347C65.5231 81.1078 44.0363 89.6151 38.341 75.4483ZM53.1014 104.17L65.2234 100.243L62.97 93.2463C64.9547 91.995 66.7343 90.493 68.2802 88.7966L74.8631 92.185L80.6599 80.791L74.3247 77.5301C74.9788 74.9335 75.2398 72.2198 75.0628 69.4772L82.221 67.1585L78.2967 54.9735L71.1386 57.2922C69.7867 55.1289 68.1422 53.2088 66.276 51.5659L69.3206 45.5815L57.9733 39.7408L54.9286 45.7252C52.5133 45.1634 50.002 44.9453 47.4668 45.1078L45.2135 38.111L33.0915 42.0375L35.3448 49.0343C33.0294 50.4933 30.9942 52.2946 29.2831 54.3471L22.9478 51.0862L17.151 62.4802L23.7339 65.8685C23.2702 68.122 23.0998 70.4514 23.252 72.8035L16.0939 75.1221L20.0184 87.3081L27.1766 84.9895C28.5285 87.1528 30.173 89.0729 32.0392 90.7157L28.4907 97.6906L39.838 103.531L43.3866 96.5564C45.8019 97.1182 48.3131 97.3364 50.8484 97.1738L53.1014 104.17Z",
    fill: "url(#paint10_radial_706_27619)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.341 75.4483C32.7935 61.1745 54.2802 52.6672 59.9768 66.8347C65.5231 81.1078 44.0363 89.6151 38.341 75.4483ZM53.1014 104.17L65.2234 100.243L62.97 93.2463C64.9547 91.995 66.7343 90.493 68.2802 88.7966L74.8631 92.185L80.6599 80.791L74.3247 77.5301C74.9788 74.9335 75.2398 72.2198 75.0628 69.4772L82.221 67.1585L78.2967 54.9735L71.1386 57.2922C69.7867 55.1289 68.1422 53.2088 66.276 51.5659L69.3206 45.5815L57.9733 39.7408L54.9286 45.7252C52.5133 45.1634 50.002 44.9453 47.4668 45.1078L45.2135 38.111L33.0915 42.0375L35.3448 49.0343C33.0294 50.4933 30.9942 52.2946 29.2831 54.3471L22.9478 51.0862L17.151 62.4802L23.7339 65.8685C23.2702 68.122 23.0998 70.4514 23.252 72.8035L16.0939 75.1221L20.0184 87.3081L27.1766 84.9895C28.5285 87.1528 30.173 89.0729 32.0392 90.7157L28.4907 97.6906L39.838 103.531L43.3866 96.5564C45.8019 97.1182 48.3131 97.3364 50.8484 97.1738L53.1014 104.17Z",
    fill: "url(#paint11_radial_706_27619)",
    fillOpacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.341 75.4483C32.7935 61.1745 54.2802 52.6672 59.9768 66.8347C65.5231 81.1078 44.0363 89.6151 38.341 75.4483ZM53.1014 104.17L65.2234 100.243L62.97 93.2463C64.9547 91.995 66.7343 90.493 68.2802 88.7966L74.8631 92.185L80.6599 80.791L74.3247 77.5301C74.9788 74.9335 75.2398 72.2198 75.0628 69.4772L82.221 67.1585L78.2967 54.9735L71.1386 57.2922C69.7867 55.1289 68.1422 53.2088 66.276 51.5659L69.3206 45.5815L57.9733 39.7408L54.9286 45.7252C52.5133 45.1634 50.002 44.9453 47.4668 45.1078L45.2135 38.111L33.0915 42.0375L35.3448 49.0343C33.0294 50.4933 30.9942 52.2946 29.2831 54.3471L22.9478 51.0862L17.151 62.4802L23.7339 65.8685C23.2702 68.122 23.0998 70.4514 23.252 72.8035L16.0939 75.1221L20.0184 87.3081L27.1766 84.9895C28.5285 87.1528 30.173 89.0729 32.0392 90.7157L28.4907 97.6906L39.838 103.531L43.3866 96.5564C45.8019 97.1182 48.3131 97.3364 50.8484 97.1738L53.1014 104.17Z",
    fill: "url(#paint12_linear_706_27619)",
    fillOpacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.341 75.4483C32.7935 61.1745 54.2802 52.6672 59.9768 66.8347C65.5231 81.1078 44.0363 89.6151 38.341 75.4483ZM53.1014 104.17L65.2234 100.243L62.97 93.2463C64.9547 91.995 66.7343 90.493 68.2802 88.7966L74.8631 92.185L80.6599 80.791L74.3247 77.5301C74.9788 74.9335 75.2398 72.2198 75.0628 69.4772L82.221 67.1585L78.2967 54.9735L71.1386 57.2922C69.7867 55.1289 68.1422 53.2088 66.276 51.5659L69.3206 45.5815L57.9733 39.7408L54.9286 45.7252C52.5133 45.1634 50.002 44.9453 47.4668 45.1078L45.2135 38.111L33.0915 42.0375L35.3448 49.0343C33.0294 50.4933 30.9942 52.2946 29.2831 54.3471L22.9478 51.0862L17.151 62.4802L23.7339 65.8685C23.2702 68.122 23.0998 70.4514 23.252 72.8035L16.0939 75.1221L20.0184 87.3081L27.1766 84.9895C28.5285 87.1528 30.173 89.0729 32.0392 90.7157L28.4907 97.6906L39.838 103.531L43.3866 96.5564C45.8019 97.1182 48.3131 97.3364 50.8484 97.1738L53.1014 104.17Z",
    fill: "url(#paint13_linear_706_27619)",
    fillOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.341 75.4483C32.7935 61.1745 54.2802 52.6672 59.9768 66.8347C65.5231 81.1078 44.0363 89.6151 38.341 75.4483ZM53.1014 104.17L65.2234 100.243L62.97 93.2463C64.9547 91.995 66.7343 90.493 68.2802 88.7966L74.8631 92.185L80.6599 80.791L74.3247 77.5301C74.9788 74.9335 75.2398 72.2198 75.0628 69.4772L82.221 67.1585L78.2967 54.9735L71.1386 57.2922C69.7867 55.1289 68.1422 53.2088 66.276 51.5659L69.3206 45.5815L57.9733 39.7408L54.9286 45.7252C52.5133 45.1634 50.002 44.9453 47.4668 45.1078L45.2135 38.111L33.0915 42.0375L35.3448 49.0343C33.0294 50.4933 30.9942 52.2946 29.2831 54.3471L22.9478 51.0862L17.151 62.4802L23.7339 65.8685C23.2702 68.122 23.0998 70.4514 23.252 72.8035L16.0939 75.1221L20.0184 87.3081L27.1766 84.9895C28.5285 87.1528 30.173 89.0729 32.0392 90.7157L28.4907 97.6906L39.838 103.531L43.3866 96.5564C45.8019 97.1182 48.3131 97.3364 50.8484 97.1738L53.1014 104.17Z",
    fill: "#FAFAFD",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_706_27619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.02 24.7072C255.02 15.4798 263.357 8.00031 273.64 8.00031C283.925 8.00031 292.262 15.4798 292.262 24.7072H162.949V8.00031H273.64",
    fill: "#939094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.993 177.077V177.577H134.493H209.573H236.401C246.91 177.577 255.522 169.922 255.522 160.37V24.7073C255.522 15.8057 263.583 8.5 273.643 8.5V8V7.5H153.114C143.205 7.5 135.077 15.8485 134.093 24.7073H133.993V26.4964V177.077Z",
    fill: "#EAE9EC",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.16 107.449L199.16 106.449C199.145 106.449 199.131 106.449 199.117 106.449L74.2286 106.574L74.1651 106.574L74.1035 106.59C67.6874 108.255 64.3154 111.729 62.5579 114.815C61.6827 116.351 61.2122 117.783 60.9603 118.834C60.8343 119.359 60.7626 119.791 60.7223 120.093C60.7022 120.244 60.6899 120.364 60.6825 120.447C60.6789 120.488 60.6764 120.52 60.6749 120.543L60.6731 120.57L60.6727 120.578L60.6726 120.581L60.6725 120.582C60.6725 120.582 60.6725 120.583 61.1719 120.607L60.6725 120.583L60.6719 120.595V120.607V276.498V276.998H61.1719H161.288C171.796 276.998 180.409 269.344 180.409 259.791L181.039 123.658V123.656C181.039 114.767 189.077 107.469 199.118 107.449C199.132 107.449 199.146 107.449 199.16 107.449L199.16 107.449Z",
    fill: "#F0F0F3",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.303 276.498C151.019 276.498 142.683 269.018 142.683 259.791H22C22 259.791 23.7576 274.757 38.3215 276.498H161.303Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.401 177.077C226.117 177.077 217.78 169.597 217.78 160.37V123.656C217.78 114.429 209.443 106.949 199.159 106.949C188.875 106.949 180.538 114.429 180.538 123.656V160.37V177.077H236.401Z",
    fill: "#AEAAAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.858 130.966H71.7637V126.957H168.858V130.966Z",
    fill: "#79747E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.31 137.812H71.7637V134.978H120.31V137.812Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.296 235.182H71.7637V231.245H165.296V235.182Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.296 242.199H71.7637V238.262H165.296V242.199Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.296 249.216H71.7637V245.28H165.296V249.216Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.964 90.0333H148.555V86.0237H241.964V90.0333Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.964 98.303H148.555V94.2935H241.964V98.303Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.538 37.6555H149.81V27.6307H180.538V37.6555Z",
    fill: "#E6E1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.547 39.6601H147.802V25.6257H182.547V39.6601ZM151.819 35.6506H178.528V29.6358H151.819V35.6506Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.146 37.6547H175.424V44.4218L169.146 37.6547Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.608 65.9741H148.555V78.0028H160.608V65.9741Z",
    fill: "#79747E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.45 49.9349H169.397V78.0029H181.45V49.9349Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.286 59.2075H189.233V78.0024H201.286V59.2075Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.708 44.4217H228.655V78.0028H240.708V44.4217Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.524 25.8768H208.472V78.0031H220.524V25.8768Z",
    fill: "#007BCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.502 184.011C136.502 166.294 122.112 151.932 104.36 151.932V184.011H136.502Z",
    fill: "#007BCC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.361 151.933C100.007 151.933 95.8642 152.817 92.0771 154.383L104.361 184.011V151.933Z",
    fill: "#49454F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.0781 154.382C80.4265 159.2 72.2207 170.639 72.2207 184.01C72.2207 201.727 86.6105 216.088 104.362 216.088C113.429 216.088 121.585 212.31 127.429 206.282L104.362 184.01L92.0781 154.382Z",
    fill: "#C0C6DC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.361 184.01L127.428 206.282C133.024 200.51 136.502 192.677 136.502 184.01H104.361Z",
    fill: "#003E66"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.857 216.547H142.362V208.069H150.857V216.547Z",
    fill: "#487390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.857 197.836H142.362V189.357H150.857V197.836Z",
    fill: "#70778B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.857 160.412H142.362V151.933H150.857V160.412Z",
    fill: "#489ED8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.857 179.124H142.362V170.645H150.857V179.124Z",
    fill: "#C0C6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.472 158.176H155.419V154.166H167.472V158.176Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.472 176.889H155.419V172.88H167.472V176.889Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.472 195.6H155.419V191.591H167.472V195.6Z",
    fill: "#C9C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.472 214.314H155.419V210.304H167.472V214.314Z",
    fill: "#C9C5CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_706_27619",
    x: 18,
    y: 7,
    width: 278.263,
    height: 278.498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_706_27619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_706_27619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_706_27619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5744 273.604) rotate(-48.4943) scale(306.639 364.677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#387DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#3A7EDF",
    stopOpacity: 0.989682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_27619",
    x1: 256.184,
    y1: 204.67,
    x2: 334.009,
    y2: 281.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_706_27619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(332.718 225.35) rotate(-151.31) scale(222.563 282.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707ADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_706_27619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.3618 8.38182) rotate(57.2087) scale(415.166 476.993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303D5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D9EE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_706_27619",
    x1: 270.241,
    y1: 295.146,
    x2: 243.738,
    y2: 128.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_706_27619",
    x1: 347.94,
    y1: 130.486,
    x2: 255.007,
    y2: 258.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303D5C",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303D5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_706_27619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(329.173 141.896) rotate(21.2141) scale(72.3964 85.0653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#387DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#3A7EDF",
    stopOpacity: 0.989682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_706_27619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(359.801 198.465) rotate(-77.1071) scale(51.1609 67.6026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707ADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_706_27619",
    x1: 329.09,
    y1: 156.775,
    x2: 371.041,
    y2: 151.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EFF0F3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_706_27619",
    x1: 397.145,
    y1: 125.712,
    x2: 383.905,
    y2: 151.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303D5C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947917,
    stopColor: "#303D5C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_706_27619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4888 51.8963) rotate(21.2141) scale(72.3964 85.0653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#387DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#3A7EDF",
    stopOpacity: 0.989682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_706_27619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.116 108.465) rotate(-77.1071) scale(51.1609 67.6026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707ADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_706_27619",
    x1: 13.4058,
    y1: 66.7755,
    x2: 55.3565,
    y2: 61.8217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EFF0F3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_706_27619",
    x1: 81.4605,
    y1: 35.7118,
    x2: 68.2208,
    y2: 61.1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303D5C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947917,
    stopColor: "#303D5C",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValReportInProgress);
export default __webpack_public_path__ + "static/media/ValReportInProgress.da8c1ec12e269d0c2a60f69bf07fbf58.svg";
export { ForwardRef as ReactComponent };